<template>
  <div class="wrap">
    <notice-modal
      v-if="openPopup"
      :src="popupList[0]"
      @close="openPopup = false"
      @noMore="
        openPopup = false;
        $store.dispatch('popup/updateMain', popupList[0]._id);
      "
    />
    <div class="graphics">
      <div class="width">
        <div class="typo">
          <img
            src="../../static/assets/img/main-graphics-title.png"
            class="pc-only"
          />
          <img
            src="../../static/assets/img/main/title.png"
            class="mobile-only"
          />
        </div>
        <div class="introduce">
          <p>
            그날의 교통상황과 기상여건에 따라
            <br />
            <b>최적거리</b>와 <b>합리적인 요금</b>을 산출합니다. <br />디버는
            <b>평균 15% 이상</b> 배송비를 절감해드립니다.
            <br />
          </p>
        </div>
        <div class="btn-wrap">
          <router-link to="/orders/form" tag="button">
            <span>주문 접수</span>
          </router-link>
          <router-link to="/my/orders?p=1" tag="button">
            <span>주문내역 조회</span>
          </router-link>
        </div>
        <img
          src="../../static/assets/img/main/graphics-mobile-bg.png"
          class="mobile-only bottom-bg"
        />
      </div>
    </div>
    <picture>
      <img
        class="dver-title-1"
        alt="똑똑한 배송 플랫폼 디버"
        :srcset="
          (require('@/assets/img/title-dver-1.png'),
          require('@/assets/img/title-dver-1@2x.png'),
          require('@/assets/img/title-dver-1@3x.png'))
        "
      />
      <img
        class="dver-title-1-t"
        alt="똑똑한 배송 플랫폼 디버"
        :srcset="
          (require('@/assets/img/title-dver-1-t.png'),
          require('@/assets/img/title-dver-1-t@2x.png'),
          require('@/assets/img/title-dver-1-t@3x.png'))
        "
      />
      <img
        class="dver-title-1-m"
        alt="똑똑한 배송 플랫폼 디버"
        :srcset="
          (require('@/assets/img/title-dver-1-m.png'),
          require('@/assets/img/title-dver-1-m@2x.png'),
          require('@/assets/img/title-dver-1-m@3x.png'))
        "
      />
    </picture>
    <!-- <div class="dver-title-1"></div> -->
    <div class="strength">
      <div class="width">
        <div class="item-row first">
          <div class="item safe">
            <div class="icon">
              <img src="../../static/assets/img/main-icn-01.svg" />
            </div>
            <div class="text">
              <div class="title">안전배송!</div>
              <div class="desc">
                배송에 특별한 주의가 필요한 케이크나
                <br />꽃다발, 와인까지도 디버에게 맡겨보세요. <br />차량배송으로
                고객의 문 앞까지 <br />안전하게 배송해드립니다
              </div>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img src="../../static/assets/img/main-icn-02.svg" />
            </div>
            <div class="text">
              <div class="title">배송추적!</div>
              <div class="desc">
                내가 보낸 물건의 현재 위치가 궁금하신가요?
                <br />디버는 실시간 배송상황을 손쉽게 <br />확인할 수 있도록
                제공해드립니다
              </div>
            </div>
          </div>
        </div>
        <div class="item-row">
          <div class="item first">
            <div class="icon">
              <img src="../../static/assets/img/main-icn-03.svg" />
            </div>
            <div class="text">
              <div class="title">운송보험!</div>
              <div class="desc">
                예기치 않은 배송사고도 디버는 책임집니다.
                <br />모든 배송물건은 디버가 가입한 <br />소화물 보험이
                적용됩니다.
              </div>
            </div>
          </div>
          <div class="item first">
            <div class="icon">
              <img src="../../static/assets/img/main-icn-04.svg" />
            </div>
            <div class="text">
              <div class="title">투명한 요금!</div>
              <div class="desc">
                배송 때마다 달라지는 가격에 지치셨나요?
                <br />디버는 배송 거리 알고리즘 프로그램을 통해 <br />합리적인
                금액을 투명하게 제공해드립니다
              </div>
            </div>
          </div>
          <div class="item first">
            <div class="icon">
              <img src="../../static/assets/img/main-icn-05.svg" />
            </div>
            <div class="text">
              <div class="title">배송원 평점!</div>
              <div class="desc">
                뛰어난 배송원들에게 맡겨보세요.
                <br />배송원 평점 제도를 활용하여 평점이 높은 <br />배송원에게
                배송 기회를 우선적으로 부여합니다
              </div>
            </div>
          </div>
        </div>
      </div>
      <picture>
        <img
          class="dver-title-2"
          alt="문서수발실의 똑똑한 변화, 스마트메일센터"
          :srcset="
            (require('@/assets/img/title-dver-2.png'),
            require('@/assets/img/title-dver-2@2x.png'),
            require('@/assets/img/title-dver-2@3x.png'))
          "
        />
        <img
          class="dver-title-2-t"
          alt="문서수발실의 똑똑한 변화, 스마트메일센터"
          :srcset="
            (require('@/assets/img/title-dver-2-t.png'),
            require('@/assets/img/title-dver-2-t@2x.png'),
            require('@/assets/img/title-dver-2-t@3x.png'))
          "
        />
        <img
          class="dver-title-2-m"
          alt="문서수발실의 똑똑한 변화, 스마트메일센터"
          :srcset="
            (require('@/assets/img/title-dver-2-m.png'),
            require('@/assets/img/title-dver-2-m@2x.png'),
            require('@/assets/img/title-dver-2-m@3x.png'))
          "
        />
      </picture>
      <div>
        <picture>
          <img
            class="dver-mailcenter"
            alt="스마트메일센터"
            :srcset="
              (require('@/assets/img/smartmail-main.png'),
              require('@/assets/img/smartmail-main@2x.png'),
              require('@/assets/img/smartmail-main@3x.png'))
            "
          />
        </picture>
        <div class="width mailcenter-under-image">
          <div class="pc-only">
            <div class="what-mailcenter">
              <span>디버 스마트메일센터란?</span>
            </div>
          </div>
          <div class="mailcenter-under-image-item" style="margin-left: auto">
            <img
              alt="스마트메일센터"
              :srcset="
                (require('@/assets/img/mailcenter/moniter-01.png'),
                require('@/assets/img/mailcenter/moniter-01@2x.png'),
                require('@/assets/img/mailcenter/moniter-01@3x.png'))
              "
            />
          </div>
          <div class="mailcenter-under-image-item" style="margin-left: 4px">
            <img
              alt="스마트메일센터"
              :srcset="
                (require('@/assets/img/mailcenter/moniter-02.png'),
                require('@/assets/img/mailcenter/moniter-02@2x.png'),
                require('@/assets/img/mailcenter/moniter-02@3x.png'))
              "
            />
          </div>
        </div>
      </div>
      <div class="introduce-mailcenter width">
        <div class="mailcenter-group">
          <div class="mailcenter-group-item">
            <img
              class="mailcenter-group-image"
              alt="스마트메일센터"
              :srcset="
                (require('@/assets/img/mailcenter/oldmail-01.png'),
                require('@/assets/img/mailcenter/oldmail-01@2x.png'),
                require('@/assets/img/mailcenter/oldmail-01@3x.png'))
              "
            />
            <p>
              <span class="dp-pc">
                <b>개인정보 노출</b>이 우려되거나,<br />
                <b>물류 분실</b>로 불편을 겪으셨나요?
              </span>
              <span class="dp-tablet">
                <b>개인정보 노출</b>이<br />
                우려되거나, <b>물류 분실</b>로<br />
                불편을 겪으셨나요?
              </span>
              <span class="dp-mobile">
                <b>개인정보 노출</b>이 우려되거나,<br />
                <b>물류 분실</b>로 불편을 겪으셨나요?
              </span>
            </p>
          </div>
          <div class="mailcenter-group-item">
            <img
              class="mailcenter-group-image"
              alt="스마트메일센터"
              :srcset="
                (require('@/assets/img/mailcenter/oldmail-02.png'),
                require('@/assets/img/mailcenter/oldmail-02@2x.png'),
                require('@/assets/img/mailcenter/oldmail-02@3x.png'))
              "
            />
            <p>
              <span class="dp-pc">
                <b>수기관리</b>되는 메일룸 서비스에<br />
                <b>불편함</b>을 느끼셨나요?
              </span>
              <span class="dp-tablet">
                <b>수기관리</b>되는<br />
                메일룸 서비스에<br />
                <b>불편함</b>을 느끼셨나요?
              </span>
              <span class="dp-mobile">
                <b>수기관리</b>되는 메일룸 서비스에<br />
                <b>불편함</b>을 느끼셨나요?
              </span>
            </p>
          </div>
        </div>
        <div class="mailcenter-group">
          <div class="mobile-only" style="margin-top: 15px">
            <div class="what-mailcenter">디버 스마트메일센터란?</div>
            <p class="introduce-title">
              물류접수/발송/보관대행까지 한번에<br />
              디버의 스마트물류관리시스템
            </p>
            <p class="introduce-content">
              현재 프론트원, LGU+, 위워크코리아 일부지점에서<br />
              디버 스마트메일센터가 운영되고 있습니다.<br />
              똑똑한 디버스마트메일센터를 만나보세요!
            </p>
          </div>
          <div class="pc-only" style="margin-top: 44px">
            <p class="introduce-title">
              물류접수/발송/보관대행까지 한번에<br />
              디버의 스마트물류관리시스템
            </p>
            <p class="introduce-content">
              현재 프론트원, LGU+, 위워크코리아 일부지점에서<br />
              디버 스마트메일센터가 운영되고 있습니다.<br />
              똑똑한 디버스마트메일센터를 만나보세요!
            </p>
          </div>
        </div>
      </div>
      <div class="company-with">
        <div class="logo-wrap">
          <span
            class="logo-item"
            v-for="(name, index) in [
              'wework',
              'lguplus',
              'spotify',
              'medialog',
              'dcamp',
              'front-1',
              'capstone',
              'freshsolution',
            ]"
            :key="index"
          >
            <img
              class="company-logo"
              alt="디버파트너"
              :srcset="require(`@/assets/img/mailcenter/logo-${name}.png`)"
            />
            <br class="pc-only" v-if="index === 3" />
            <br class="mobile-only" v-if="index === 2" />
            <br class="mobile-only" v-if="index === 5" />
          </span>
        </div>
        <hr />
        <span>다양한 기업들이 디버와 함께하고 있습니다</span>
      </div>
      <div class="contact-us">
        <div class="contact-box alliance">
          <div>
            <div class="title">제휴 문의</div>
            <span class="dp-pc"
              >고객의 배송 경험을 바꾸고 싶은 당신을 기다립니다.</span
            >
            <span class="dp-tablet"
              >고객의 배송 경험을 바꾸고 싶은 당신을 <br />기다립니다.</span
            >
            <span class="dp-mobile"
              >고객의 배송 경험을 바꾸고 싶은 당신을 기다립니다.</span
            >
          </div>
          <div class="mail-btn">
            <a href="mailto:help@dvercorp.co.kr">help@dvercorp.co.kr</a>
          </div>
        </div>
        <div class="contact-box channel" @click="openChannel">
          <div class="title">채널톡으로 간편하게 문의해 주세요</div>
          <div class="kakao-channel">
            <img
              class="kakao-logo"
              alt="카카오채널"
              :srcset="require(`@/assets/img/ic-kakao-ch@3x.png`)"
            />카카오 채널톡 <span style="font-weight: bold">디버</span>
          </div>
          <div class="work-time">
            <div style="white-space: pre-wrap">
              <div style="padding-bottom: 6px">평일 08:00 - 22:00</div>
              <div>주말∙공휴일 08:00 - 21:00</div>
            </div>
          </div>
        </div>
      </div>
      <!--end of width -->
      <!-- <div class="be-rider">
        <a
          href="https://play.google.com/store/apps/details?id=kr.co.dver.rider"
        >
          <img
            src="../../static/assets/img/btn-howto.png"
            class="howto pc-only"
          />
          <img
            src="../../static/assets/img/main-btn-howto-mobile.png"
            class="howto mobile-only"
          />
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import noticeModal from "@/components/modal/noticeTemplate/layout";

export default {
  name: "Main",
  components: {
    noticeModal,
  },
  metaInfo: {
    title: "홈",
  },
  data() {
    return {
      openPopup: false,
      popupList: [],
    };
  },
  created() {
    /**
     * 팝업 목록 불러오기
     */
    this.$store
      .dispatch("notice/getMainPopup")
      .then((res) => {
        this.popupList = res.popups;
        if (!this.popupList.length) return;
        this.$store
          .dispatch("popup/checkMain", this.popupList[0]._id)
          .then((res) => {
            if (res === "show") this.openPopup = true;
            else this.openPopup = false;
          });
      })
      .catch((e) => {});
  },
  methods: {
    openChannel() {
      window.open("https://pf.kakao.com/_jvxdeT");
    },
  },
};
</script>

<style src="./Main.component.css" scoped />
